import React from 'react';
import Parameter from '../component/view/Parameter';
import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';

const ParameterPage = () => {
  return (
    <div style={{paddingRight: 10, lineHeight: 0.5, paddingBottom: 10}}>
      <h2 style={{textAlign: 'center'}}>
        <Trans>Configuracion de los parametros Generales</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <Parameter />
    </div>
  );
};

export default ParameterPage;
